module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "c-loader u-fixed u-pos-tl u-zindex--10 u-flex u-flex-ai--center u-flex-jc--center u-flex-fd--column u-fit-v u-bg--white-near",
    class: [_vm.isActive ? 'is-visible' : 'is-hidden']
  }, [_c('div', {
    staticClass: "c-loader__container u-relative u-w8of10 u-bg--white"
  }, [_c('div', {
    staticClass: "c-loader__container__progress u-absolute u-pos-tl u-fit u-bg--brand-gold",
    style: ({
      'transform': 'scaleX(' + _vm.progress + ') translateZ(0)'
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "u-marg-t-xs u-8of10 u-overflow-h"
  }, [_c('div', {
    staticClass: "c-loader__text u-relative u-inline-block t-ffamily--domaine t-fweight--bold t-text--xxs u-uppercase u-color--black-near",
    class: [_vm.content && _vm.content.label_loading && _vm.isActive ? 'is-visible' : 'is-hidden'],
    domProps: {
      "innerHTML": _vm._s(_vm.content && _vm.content.label_loading ? _vm.content.label_loading : 'Loading...')
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fbaf6c1e"}!./src/scripts/components/app-loader/template.html
// module id = 205
// module chunks = 0